import styled from 'styled-components';

export const TextSection = styled.div`
  background: #f9f9f9;
  padding: 8px 0;
  color: #000;
`;

export const TextWrapper = styled.div`
  max-width: 1100px;
  margin: 20px auto;
  text-align: center;
`;

export const Title = styled.h4`
  font-size: 1rem;
  color: #888;
  margin-bottom: 10px;
  text-transform: uppercase;
`;

export const Headline = styled.h2`
  font-size: 2rem;
  color: #222;
  margin-bottom: 20px;
`;

export const Description = styled.p`
  font-size: 1rem;
  color: #444;
  line-height: 1.6;
  text-align: justify; /* <-- this justifies the paragraph text */
`;
